import { render } from "./DangerButton.vue?vue&type=template&id=7845957e"
import script from "./DangerButton.vue?vue&type=script&lang=js"
export * from "./DangerButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__